import type { SoQuyTienMatRow } from '@/types/schemas';
import type { ExcelColumnMapping } from './types';
import { formatDate } from '@/lib/formatUtils';

export const SO_QUY_TIEN_MAT_COLUMNS: ExcelColumnMapping<SoQuyTienMatRow>[] = [
  { header: 'Đơn vị', width: 20, resolver: row => row.unit_id },
  {
    header: 'Ngày c/từ',
    width: 20,
    resolver: row => row.ngay_ct && formatDate(row.ngay_ct)
  },
  { header: 'Số c/từ', width: 20, resolver: row => row.so_ct },
  { header: 'Mã khách hàng', width: 20, resolver: row => row.ma_kh },
  { header: 'Tên khách hàng', width: 30, resolver: row => row.ten_kh },
  { header: 'Diễn giải', width: 40, resolver: row => row.dien_giai },
  { header: 'Tk đối ứng', width: 18, resolver: row => row.tk_du },
  { header: 'Ngoại tệ', width: 18, resolver: row => row.ma_nt },
  { header: 'Tỷ giá', width: 18, resolver: row => Number(row.ty_gia) },
  { header: 'Ps nợ', width: 18, resolver: row => Number(row.ps_no) },
  { header: 'Ps có', width: 18, resolver: row => Number(row.ps_co) },
  { header: 'Số dư', width: 18, resolver: row => Number(row.du_tt) },
  { header: 'Bộ phận', width: 18, resolver: row => row.ma_bp },
  { header: 'Vụ việc', width: 18, resolver: row => row.ma_vv },
  { header: 'Hợp đồng', width: 18, resolver: row => row.ma_hd },
  { header: 'Đợt thanh toán', width: 18, resolver: row => row.ma_dtt },
  { header: 'Khế ước', width: 18, resolver: row => row.ma_ku },
  { header: 'Phí', width: 18, resolver: row => row.ma_phi },
  { header: 'Sản phẩm', width: 18, resolver: row => row.ma_sp },
  { header: 'Lệnh sản xuất', width: 18, resolver: row => row.ma_lsx },
  { header: 'C/p không h/lệ', width: 18, resolver: row => row.ma_cp0 },
  { header: 'Mã c/từ', width: 18, resolver: row => row.ma_ct }
];
